module.exports = __webpack_public_path__ + "media/images/client/favicons/favicon-0d06a4036205ae2a979d7715d07c0034.ico";